import React from 'react';

import Plot from 'react-plotly.js';
import { usePunteggi } from '../reducers';
import { Evento } from '../api/types';
import { LoadingCircle } from '../components'
import { rgb_string_from_name } from '../utils'
import { sortClassifica } from '../api';


type PunteggiStoria = ReturnType<typeof usePunteggi>
type Classifica = PunteggiStoria["states"][0]["classifica"]

interface IProps {
  nomi: { [squadra: string]: string; },
  evento: Evento,
  classifica: Classifica
}


const IstogrammaPunteggi = (props: IProps) => {
  const { evento, nomi: all_nomi, classifica: classifica_unsorted } = props;

  if (!evento) {
    return <LoadingCircle />
  }

  const adesso = new Date();
  const inizio = new Date(evento.inizio);
  if (inizio.getTime() > adesso.getTime()) {
    return <p>{"L'evento non è ancora iniziato."}</p>;
  }

  const classifica = sortClassifica(classifica_unsorted, -1, "p", -1);

  const colori = classifica.map(item => rgb_string_from_name(item.nome));
  const nomi = classifica.map(item => all_nomi[item.nome]);
  const punteggi = classifica.map(item => {
    const { totale } = item;
    const montepremi_totale = item.problemi
      .map(iitem => iitem.punti_parziali[1])
      .reduce((acc, cur) => acc + cur)
    return [totale - montepremi_totale, montepremi_totale];
  })

  // Sistemiamo i negativi
  const punteggi_nn = punteggi.map(couple => {
    if (couple[0] >= 0) return couple
    if (couple[1] >= -couple[0]) return [0, couple[1] + couple[0]]
    return [couple[1] + couple[0], 0]
  })

  const pti_base = {
    // Notare il fatto che sono invertiti perché è orizzontale.
    x: punteggi_nn.map(item => item[0]),
    y: nomi,
    marker: {
      color: colori,
    },
    name: "Punteggio base",
    type: 'bar' as 'bar',
    orientation: 'h' as 'h',
  }
  const pti_montepremi = {
    x: punteggi_nn.map(item => item[1]),
    y: nomi,
    name: "Punteggio difficoltà",
    marker: {
      color: '#ffd700',
    },
    type: 'bar' as 'bar',
    orientation: 'h' as 'h',
  }
  const data = [pti_base, pti_montepremi];
  return (
    <Plot
      data={data}
      layout={{
        barmode: 'stack',
        title: "Punteggio",
        autosize: true,
        margin: { l: 200 },
      }}
      style={{ width: "100%", height: "100%", minHeight: "600px" }}
    />
  )

}

export default IstogrammaPunteggi;
